"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
/**
 * @hidden
 */
exports.prevView = 'multiviewcalendar.prevView';
/**
 * @hidden
 */
exports.nextView = 'multiviewcalendar.nextView';
/**
 * @hidden
 */
exports.increaseValue = 'dateinput.increment';
/**
 * @hidden
 */
exports.decreaseValue = 'dateinput.decrement';
/**
 * @hidden
 */
exports.today = 'calendar.today';
/**
 * @hidden
 */
exports.toggleCalendar = 'datepicker.toggleCalendar';
/**
 * @hidden
 */
exports.swapStartEnd = 'daterangepicker.swapStartEnd';
/**
 * @hidden
 */
exports.start = 'daterangepicker.start';
/**
 * @hidden
 */
exports.end = 'daterangepicker.end';
/**
 * @hidden
 */
exports.separator = 'daterangepicker.separator';
/**
 * @hidden
 */
exports.toggleDateTimeSelector = 'datetimepicker.toggleDateTimeSelector';
/**
 * @hidden
 */
exports.now = 'timepicker.now';
/**
 * @hidden
 */
exports.selectNow = 'timepicker.selectNow';
/**
 * @hidden
 */
exports.timePickerCancel = 'timepicker.cancel';
/**
 * @hidden
 */
exports.timePickerSet = 'timepicker.set';
/**
 * @hidden
 */
exports.toggleTimeSelector = 'timepicker.toggleTimeSelector';
/**
 * @hidden
 */
exports.toggleClock = 'timepicker.toggleClock';
/**
 * @hidden
 */
exports.date = 'datetimepicker.date';
/**
 * @hidden
 */
exports.time = 'datetimepicker.time';
/**
 * @hidden
 */
exports.dateTimePickerCancel = 'datetimepicker.cancel';
/**
 * @hidden
 */
exports.dateTimePickerSet = 'datetimepicker.set';
/**
 * @hidden
 */
exports.messages = (_a = {},
    _a[exports.today] = 'TODAY',
    _a[exports.now] = 'NOW',
    _a[exports.timePickerSet] = 'Set',
    _a[exports.timePickerCancel] = 'Cancel',
    _a[exports.date] = 'Date',
    _a[exports.time] = 'Time',
    _a[exports.dateTimePickerCancel] = 'Cancel',
    _a[exports.dateTimePickerSet] = 'Set',
    _a[exports.start] = 'Start',
    _a[exports.end] = 'End',
    _a[exports.separator] = ' ',
    _a[exports.selectNow] = 'Select Now',
    _a[exports.toggleTimeSelector] = 'Toggle TimeSelector',
    _a[exports.toggleClock] = 'Toggle Clock',
    _a[exports.increaseValue] = 'Increase value',
    _a[exports.decreaseValue] = 'Decrease value',
    _a[exports.toggleCalendar] = 'Toggle calendar',
    _a[exports.prevView] = 'Navigate to previous view',
    _a[exports.nextView] = 'Navigate to next view',
    _a[exports.swapStartEnd] = 'Swap start and end values',
    _a[exports.toggleDateTimeSelector] = 'Toggle date-time selector',
    _a);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-dateinputs@3.18.0_@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_r_2yelhkp6sdgaltctm3m4k3bqy4/~/@progress/kendo-react-dateinputs/dist/npm/messages/index.js
// module id = 46
// module chunks = 0